import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import useRewards from '../../../../../hooks/useRewards';
import { CertificatesContainer, RedeemHeaderContainer, RedeemHeaderTitle } from './subcomponents';
import CertificatesList from '../CertificatesList';
import NoCertificates from '../NoCertificates';
import { filterActiveCertificates } from '../../../../../helpers/certificateHistoryUtils';
var Certificates = function () {
    var t = useTranslation().t;
    var _a = useRewards(), certificates = _a.certificates, clientId = _a.clientId, hasCertificateHistory = _a.hasCertificateHistory;
    var hasActiveCertificates = false;
    var activeCertificates = filterActiveCertificates(certificates);
    if (activeCertificates &&
        activeCertificates.certificateDetails &&
        activeCertificates.certificateDetails.length > 0) {
        hasActiveCertificates = activeCertificates.certificateDetails.length > 0;
    }
    return (_jsx(CertificatesContainer, { children: hasCertificateHistory && hasActiveCertificates ? (_jsxs(_Fragment, { children: [clientId !== 'jcrew' && (_jsx(RedeemHeaderContainer, { children: _jsx(RedeemHeaderTitle, { children: t('fullDetailsPage.myRewardsCertificates') }) })), _jsx(CertificatesList, { activeCertificates: activeCertificates })] })) : (_jsx(NoCertificates, {})) }));
};
export default Certificates;
